import React from "react";
import formatUrl from "utils/FormatUrl";
import style from "./similaireCards.module.css";

function index({ title, posts, lang, page }) {
  return (
    <div className={style.card}>
      <span className={style.title}>{title}</span>
      <div className={style.links}>
        {posts.length > 0 &&
          posts.map((e, index) => {
            return (
              <a
                rel={
                  e?.slug?.current?.includes("list") ||
                  e?.slug?.current?.includes("map") ||
                  e?.slug?.current?.includes("?") ||
                  e?.slug?.current?.includes("conditions") ||
                  e?.slug?.current?.includes("contact")
                    ? "noindex, nofollow, noreferrer"
                    : "dofollow"
                }
                href={formatUrl(`/${page}/${e.slug.current}`, lang)}
              >
                {e.title[lang]}
              </a>
            );
          })}
      </div>
    </div>
  );
}

export default index;
